export function caseInsensitiveEquals(a: string, b: string) {
    return typeof a === 'string' && typeof b === 'string'
        ? a.localeCompare(b, undefined, {sensitivity: 'accent'}) === 0
        : a === b;
}

export function camelToKebab(str: string) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
